import { NavLink, Link } from "react-router-dom";
import { LayoutDashboard, Send, History, LogOut, Shield, Package, ArrowRightLeft, ChevronsLeft, Home } from "lucide-react";
import clsx from "clsx";
import { useAuthStore } from "@/store/auth-store";
import { useUIStore } from "@/store/ui-store"; // 🛠️ USING STORE FOR MOBILE MENU
import { useNavigate } from "react-router-dom";
import { APP_NAME } from "@/lib/constants";

const NAV = [
  { to: "/agent",             label: "Dashboard",       icon: LayoutDashboard },
  { to: "/agent/orders",      label: "Shop Orders",     icon: Package },
  { to: "/agent/distribute",  label: "Send to User",    icon: Send },
  { to: "/agent/transfer",    label: "Agent Transfer",  icon: ArrowRightLeft },
  { to: "/agent/history",     label: "History",         icon: History },
];

export function AgentSidebar() {
  const { user, logout } = useAuthStore();
  const { mobileMenuOpen, closeMobileMenu } = useUIStore(); // 🛠️ NEW
  const nav = useNavigate();

  return (
    <>
      {/* 📱 Backdrop Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-surface-900/60 backdrop-blur-sm lg:hidden transition-opacity" 
          onClick={closeMobileMenu} 
        />
      )}

      {/* 💻 Responsive Sidebar */}
      <aside className={clsx(
        "fixed lg:sticky top-0 left-0 z-50 h-screen w-[280px] bg-gradient-to-b from-surface-900 to-surface-950 text-surface-100 flex flex-col transition-transform duration-300 shadow-2xl lg:shadow-none pb-20 lg:pb-0",
        mobileMenuOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
      )}>
        
        {/* Header */}
        <div className="flex flex-col border-b border-surface-800 shrink-0">
          <div className="h-16 flex items-center justify-between px-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-warning-500 to-warning-700 grid place-items-center">
                <Shield className="h-5 w-5 text-white" />
              </div>
              <div>
                <div className="text-sm font-bold leading-tight">{APP_NAME}</div>
                <div className="text-2xs text-surface-400">Agent Portal</div>
              </div>
            </div>
            {/* Close Button (Mobile Only) */}
            <button onClick={closeMobileMenu} className="lg:hidden p-2 rounded-lg text-surface-400 hover:bg-surface-800 transition-colors">
              <ChevronsLeft className="h-5 w-5" />
            </button>
          </div>
          
          <div className="px-4 pb-3 pt-1 flex flex-col gap-2">
            <Link to="/" onClick={closeMobileMenu}>
              <button className="w-full flex items-center justify-center gap-2 bg-surface-800 hover:bg-surface-700 text-surface-200 font-semibold text-xs py-2 rounded-lg transition-colors border border-surface-700">
                <Home className="w-3.5 h-3.5" /> Back to Storefront
              </button>
            </Link>
            <Link to="/dashboard" onClick={closeMobileMenu}>
              <button className="w-full flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white font-semibold text-xs py-2 rounded-lg transition-colors">
                <LayoutDashboard className="w-3.5 h-3.5" /> Customer Dashboard
              </button>
            </Link>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 px-3 space-y-1.5 overflow-y-auto">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to} to={to} end={to === "/agent"}
              onClick={closeMobileMenu}
              className={({ isActive }) => clsx(
                "flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-warning-600/20 text-warning-300 ring-1 ring-warning-500/30"
                  : "text-surface-400 hover:bg-surface-800 hover:text-surface-100",
              )}
            >
              <Icon className="h-5 w-5" />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Profile Footer */}
        <div className="p-3 border-t border-surface-800 shrink-0">
          <div className="flex items-center gap-3 px-2 py-2">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-warning-400 to-warning-600 grid place-items-center text-surface-900 text-xs font-bold shrink-0">
              {user?.full_name?.charAt(0)}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-semibold truncate text-white">{user?.full_name}</div>
              <div className="text-2xs text-surface-500 font-mono truncate">{user?.user_id}</div>
            </div>
            <button
              onClick={() => { logout(); nav("/login"); }}
              className="p-1.5 rounded-md hover:bg-surface-800 text-surface-400"
              title="Logout"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}